export function getServerEndpoint() {
  return window.location.protocol + "//" + getServerEndpointNoProtocol();
}

export function getServerEndpointNoProtocol() {
  let serverEndpoint = "localhost:3005/"; /*'localhost:3005/'*/ /* 'iahmed:3005/' */ /*"172.19.91.147:4001/"*/
  if (process.env.NODE_ENV === "production") {
    serverEndpoint = window.location.host + "/"; //window.location.protocol + '//'+ window.location.host +'/';
  }

  return serverEndpoint;
}
export async function redirectToWebApp(path = "", params) {
  let redirectDevPath = `localhost:5173`;
  const baseUrl = process.env.NODE_ENV === "production" ? window.location.host + "/webapp" : redirectDevPath;
  const queryString = new URLSearchParams(params).toString();
  const targetUrl = path
    ? `${baseUrl}/${path}${queryString ? `?${queryString}` : ""}`
    : `${baseUrl}${queryString ? `?${queryString}` : ""}`;
  if ("caches" in window) {
    const cacheNames = await caches.keys();
    for (const cacheName of cacheNames) {
      await caches.delete(cacheName);
    }
  }
  window.location.href = window.location.protocol + "//" + targetUrl;
}



// WEBPACK FOOTER //
// ./src/utils/serverEndpoint.js